import { render, staticRenderFns } from "./ResourcePrimaryFilters.vue?vue&type=template&id=188a08e8&"
import script from "./ResourcePrimaryFilters.vue?vue&type=script&lang=js&"
export * from "./ResourcePrimaryFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports